import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex flex-col space-y-5"
}
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Overview ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-2" }, null, -1)
const _hoisted_5 = { class: "w-full grid grid-cols-12 gap-3 px-3 border-[1px] border-grey300 rounded-md" }
const _hoisted_6 = { class: "col-span-12 grid grid-cols-4 flex-wrap gap-4" }
const _hoisted_7 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Top Provider ")
const _hoisted_9 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Total Inflow ")
const _hoisted_11 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Total Outflow ")
const _hoisted_13 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" This Week Payout ")
const _hoisted_15 = { class: "w-full grid grid-cols-2 gap-4" }
const _hoisted_16 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-4" }
const _hoisted_17 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Recent Bookings ")
const _hoisted_19 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_growth_box = _resolveComponent("roof-growth-box")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_growth_graph = _resolveComponent("roof-growth-graph")!
  const _component_roof_financial_chart = _resolveComponent("roof-financial-chart")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_ctx.DashboardOverview)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_roof_header_text, {
            size: "xl",
            customClass: '!font-extrabold'
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_roof_growth_box, {
            label: 'Total Users',
            "growth-data": 
          _ctx.DashboardOverview?.GetDashboardOverview.growth_data.total_users
        
          }, null, 8, ["growth-data"]),
          _createVNode(_component_roof_growth_box, {
            label: 'Total Providers',
            "growth-data": 
          _ctx.DashboardOverview?.GetDashboardOverview.growth_data.total_providers
        
          }, null, 8, ["growth-data"]),
          _createVNode(_component_roof_growth_box, {
            label: 'Transaction Volume (NGN)',
            "growth-data": 
          _ctx.DashboardOverview?.GetDashboardOverview.growth_data.transaction_volume
        ,
            "is-currency": true
          }, null, 8, ["label", "growth-data"]),
          _createVNode(_component_roof_growth_box, {
            label: 'Total Bookings',
            "growth-data": 
          _ctx.DashboardOverview?.GetDashboardOverview.growth_data.total_bookings
        
          }, null, 8, ["growth-data"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_roof_header_text, { size: "lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.DashboardOverview.GetDashboardOverview.analysis?.top_provider), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_roof_normal_text, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_roof_header_text, { size: "lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Logic.Common.convertToMoney(
              _ctx.DashboardOverview.GetDashboardOverview.analysis?.total_income,
              true,
              'ngn'
            )), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_roof_normal_text, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_roof_header_text, { size: "lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Logic.Common.convertToMoney(
              _ctx.DashboardOverview.GetDashboardOverview.analysis?.total_payouts,
              true,
              'ngn'
            )), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_roof_normal_text, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_roof_header_text, { size: "lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Logic.Common.convertToMoney(
              _ctx.DashboardOverview.GetDashboardOverview.analysis
                ?.this_week_payouts,
              true,
              'ngn'
            )), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_roof_normal_text, null, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_roof_growth_graph, {
            data: _ctx.UserGrowthData,
            label: 'User Growth',
            countLabelPlural: 'users',
            "count-label-singular": 'user',
            "data-source": _ctx.Logic.Users.GetUserGrowth
          }, null, 8, ["data", "data-source"]),
          _createVNode(_component_roof_financial_chart, {
            data: _ctx.CreditDebitStatisticsData,
            label: 'Earning Statistics',
            itemLabel1: "Inflow",
            itemLabel2: "Outflow",
            "data-source": _ctx.Logic.Financials.GetCreditDebitStatistics
          }, null, 8, ["data", "data-source"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_roof_header_text, { size: "lg" }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_roof_table, {
              tableStructure: _ctx.Logic.Booking.BookingTableStructure,
              paginatedData: _ctx.latestBookings,
              "table-date-source": _ctx.Logic.Booking.BookingSource,
              "sub-page-route": '/bookings/'
            }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}